import React, { useContext } from 'react';

import styled from '@emotion/styled';

import CloseIcon from '../../Icons/CloseIcon';
// import CancelIcon from '../../Icons/CancelIcon';
import { TableContext } from '../TableContext';

// import ArrowLeftIcon from '../../Icons/ArrowLeftIcon';

interface TableSliderContentWrapperProps {
  label: string;
  children: React.ReactNode;
}

const TableSliderContentWrapper: React.FC<TableSliderContentWrapperProps> = ({
  label,
  children,
}) => {
  const tableContext = useContext(TableContext);
  return (
    <Container>
      <HeaderArea>
        <div
          className='arrow_back_icon'
          onClick={() => tableContext?.setShowTableSlider(false)}
        >
          {/* <ArrowLeftIcon /> */}
          <span>L</span>
        </div>

        <div>{label}</div>
        <div
          className='icon'
          onClick={() => tableContext?.setShowTableSlider(false)}
        >
          <CloseIcon />
        </div>
      </HeaderArea>
      <>{children}</>
    </Container>
  );
};

export default TableSliderContentWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  padding: 40px 28px;
  background-color: white;
  overflow-y: auto;
  gap: 34px;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const HeaderArea = styled.div`
  display: flex;
  color: #0E1A13;
  font-weight: 700;
  font-size: 32.11px;
  justify-content: space-between;
  width: 100%;
  height: fit-content;

  @media (max-width: 884px) {
    font-size: 24px;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
  }

  & > .icon {
    margin-top: -10px;
    cursor: pointer;

    transform: scale(100%);
    transition: transform 0.3s ease-out;

    &:hover {
      transform: scale(110%);
    }

    @media (max-width: 884px) {
      display: none;
    }
  }

  & > .arrow_back_icon {
    display: none;

    @media (max-width: 884px) {
      display: block;
    }
  }
`;
